import React, { useState, useEffect, useReducer } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dropdown, Button, Modal } from "react-bootstrap";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import './Roster.css'
import {
  GetBarbers,
  CreateLeave,
  GetRoster,
  UpdateLeave,
  DeleteLeave
} from './Requests.js'
import {PulseLoader } from "react-spinners";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { use } from "react";
import { ToastContainer} from "react-toastify";
import {
    notifySuccess,
    notifyError
} from '../Response/ResposeHandler'
  const initialState = false;

  const reducer = (state, action) =>{
    switch (action.type){
        case 'addLeaveOpen':
          return { ...state, addLeave: true }
        case 'addLeaveClose':			
          return { ...state, addLeave: false }
        case 'editLeaveOpen':
          return { ...state, editLeave: true }
        case 'editLeaveClose':			
          return { ...state, editLeave: false }
        default:
        return state	
    }	
  }

  const Roster = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [staff, setStaff] = useState([])
    const [selectedStaff, setSelectedStaff] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    let errorsObj = { staff: '', startDate: '', endDate: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [isLoading, setIsloading] = useState(true)
    const [roster, setRoster] = useState()
    const [rosterData, setRosterData] = useState()
    const [showLeaveOnly, setShowLeaveOnly] = useState(false)
    const [leaveToEdit, setLeaveToEdit] = useState()
    const [selectDate, setSelectedDate] = useState(new Date())

    useEffect(() => {
        GetStaffWrapper()
        OnDateChange(new Date())
    }, []);

    function ResetFields()
    {
      setSelectedStaff()
      setStartDate()
      setEndDate()
      setErrors({ staff: '', startDate: '', endDate: '' })
      setLeaveToEdit()
    }
    function GetStaffWrapper() {
      GetBarbers().then((res) => {
          var tempVar = []
          res.data.map((item, index) => {
              var obj = { value: item.barberId, label: item.name, isDisabled: item.status === 1 ? false : true }
              tempVar.push(obj)
          })
          setStaff(tempVar)
          // const idset = new Set(props.site.staffIds.map(item => item))
          // const common = tempVar.filter(item => idset.has(item.value))
          // setSiteStaff(common)
      }).catch((error) => {
      }).finally((f) => {
          // setShow(true)
      })
    }

    function SubmitLeave(e)
    {
      e.preventDefault()
      let error = false;
      const errorObj = { ...errorsObj };
      if (selectedStaff === undefined || selectedStaff === null)
      {
        errorObj.staff = 'Please select a staff member';
        error = true;
      }

      if (startDate === undefined || startDate === null)
      {
        errorObj.startDate = 'Please choose a start date';
        error = true;
      }

      if (endDate === undefined || endDate === null)
      {
        errorObj.endDate = 'Please choose a start date';
        error = true;
      }
      else
      {
        if (endDate < startDate)
        {
          errorObj.endDate = 'The end date cannot be before the start date';
          error = true;
        }
      }
      setErrors(errorObj);
      
      if (error) {
        return
      } else {


        CreateLeave(
          selectedStaff.value,
          startDate,
          endDate
          ).then((res) => {
            if (res.status === 200)
            {
              notifySuccess("Leave Saved")
            }
          
        }).catch((error) => {
          if (error.response.data === "You have a leave booked that is within these dates")
          {
            notifyError("You have a leave booked within these time already")
          }
          else{
            notifyError("There was an issue saving your leave, please try again, or contact support")
          }

        }).finally((f) => {
          OnDateChange(selectDate)
          dispatch({type:'addLeaveClose'})
        })  
      }
    }
    
    function SubmitEditLeave(e)
    {
      e.preventDefault()
      let error = false;
      const errorObj = { ...errorsObj };
      if (selectedStaff === undefined || selectedStaff === null)
      {
        errorObj.staff = 'Please select a staff member';
        error = true;
      }

      if (startDate === undefined || startDate === null)
      {
        errorObj.startDate = 'Please choose a start date';
        error = true;
      }

      if (endDate === undefined || endDate === null)
      {
        errorObj.endDate = 'Please choose a start date';
        error = true;
      }
      else
      {
        if (endDate < startDate)
        {
          errorObj.endDate = 'The end date cannot be before the start date';
          error = true;
        }
      }
      setErrors(errorObj);
      
      if (error) {
        return
      } else {
        UpdateLeave(
          leaveToEdit,
          selectedStaff.value,
          startDate,
          endDate
          ).then((res) => {
            if (res.status === 200)
            {
              notifySuccess("Leave Updated")
            }
          dispatch({type:'addLeaveClose'})
        }).catch((error) => {
          if (error.response.data === "You have a leave booked that is within these dates")
          {
            notifyError("You have a leave booked within these time already")
          }
          else{
            notifyError("There was an issue updating your leave, please try again, or contact support")
          }

        }).finally((f) => {
          OnDateChange(selectDate)
          dispatch({type:'editLeaveClose'})
        })  
      }
    }

    function SubmitDeleteLeave(e)
    {
      e.preventDefault()
   
      DeleteLeave(
        leaveToEdit,
        ).then((res) => {
          if (res.status === 200)
          {
            notifySuccess("Leave Deleted")
          }
        dispatch({type:'addLeaveClose'})
      }).catch((error) => {
        notifyError("There was an issue deleting your leave, please try again, or contact support")
        
      }).finally((f) => {
        OnDateChange(selectDate)
        dispatch({type:'editLeaveClose'})
      })  
      
    }

    function OnDateChange(date)
    {
      setSelectedDate(date)
      setIsloading(true)
        GetRoster(date).then((res) => {
            if (res.status === 200)
            {
              setRosterData(res.data)
              if (showLeaveOnly)
              {
                setRoster(res.data.filter(x => x.leaveId !== null))
              }
              else{
                setRoster(res.data)
              }
              
              // notifySuccess("Roster")
            }
        }).catch((error) => {
          // notifyError("There was an issue saving your leave, please try again, or contact support")
        }).finally((f) => {
          setIsloading(false)
        })  
    }

    function onEditLeaveClick(val)
    {
      setSelectedStaff(staff.filter(x=>x.value === val.staffId)[0])
      setStartDate(dayjs(val.startDateTime))
      setEndDate(dayjs(val.endDateTime))
      setLeaveToEdit(val.leaveId)

      dispatch({type:'editLeaveOpen'})
    }

    function onToggleChange(e)
    {
      if (e.target.checked)
      {
        setRoster(roster.filter(x => x.leaveId !== null))
      }
      else{
        setRoster(rosterData)
      }
      setShowLeaveOnly(e.target.checked)
    }

    return (
    <div>
      <ToastContainer />
      <Container style={{marginTop:"0"}}>
        <div className="roster-toolbar-one" style={{display:"flex", justifyContent: "space-between"}}>
              <div className="roster-toggle-container">
              <span className='me-3 mt-1'>Show Staff on leave only</span>
                <input
                onChange={(e) => {onToggleChange(e)}}
                className="toggle-switch"
                type="checkbox"
                // defaultChecked={false}
                checked={showLeaveOnly}
                id="logon"
                />
                <label htmlFor='logon' className="switch-label"/>
            </div>
          <div className="mt-2">
            <Link to={"#"} className="btn-custom btn-primary ms-1" onClick={() =>{ dispatch({type:'addLeaveOpen'}); ResetFields();}}>Add Leave</Link>	
          </div>
        </div>
          <div className="roster-toolbar-two" style={{display:"flex", justifyContent: "end"}}>
            <Link to={"#"} className="btn-custom btn-primary ms-1" onClick={() =>{ dispatch({type:'addLeaveOpen'}); ResetFields();}}>Add Leave</Link>	
        </div>
        <Row>
          <Col className="mt-3" xxl={4} xl={4} lg={5} md={12} sm={12}>
          <div style={{marginLeft:"auto", marginRight:"auto"}}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StaticDatePicker
                 defaultValue={dayjs()}
                 disablePast
                  disableHighlightToday
                //  maxDate={dayjs().add(2, 'months')}
                  componentsProps={{ actionBar: { actions: [ ] }, toolbar: {hidden: true} }}
                 onChange={(date) => {OnDateChange(date);}}
              />
            </LocalizationProvider>
            </div>
            <div className="roster-toggle-container roster-toggle-two">
              <span className='me-3 mt-4'>Show Staff on leave only</span>
              <div className="">
                <input
                onChange={(e) => {onToggleChange(e)}}
                className="toggle-switch"
                type="checkbox"
                // defaultChecked={false}
                checked={showLeaveOnly}
                id="logon"
                />
                <label htmlFor='logon' className="switch-label"/>
              </div>
            </div>
          </Col>

          <Col style={{marginLeft:"auto", marginRight:"auto"}}>
            <div className="roster-table-container">
              <div className="data-table-wrapper">
                <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                  <div style={{marginTop:"1rem"}}>
                    <PulseLoader 
                        color={'#333'}
                        loading={isLoading}
                        size={25}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        style={{marginLeft:"auto"}}
                    />
                  </div>
                </div>

                {isLoading? <></>
                :
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Hours</th>
                      <th>Breaks</th>
                      <th>Leave</th>
                    </tr>
                  </thead>
                <tbody>
            {roster.length === 0 ? <></>
            :
            roster.map((val, index) => (
                <tr key={index}>
                  <td>{val.staffName}</td>
                  <td>{val.workingHours}</td>
                  <td>{val.breaks}</td>
                  <td>
                    {val.leaveId !== null ? ((new Date(val.startDateTime)).getDate()+"/" +(dayjs(val.startDateTime).month()+1) + " - " + (new Date(val.endDateTime)).getDate()+"/" +((dayjs(val.endDateTime)).month()+1)) : '-'}
                    {val.leaveId !== null ?
                    <IconButton onClick={() => { onEditLeaveClick(val) }} aria-label="delete" size="small" style={{ justifyContent: "right", marginLeft:"0.6rem" }}>
                      <EditIcon fontSize="small" style={{ justifyContent: "right" }} />
                    </IconButton>
                    :
                    <></>
                    }

                  </td>
              </tr>
            ))}
          </tbody>
                  
                </table>
            }
            {!isLoading ?
            roster.length === 0 ?
                                <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div style={{marginTop:"2rem"}}>
        <p>No Staff Members</p>
        </div>
        </div>
        :
        <></>
        :
        <></>
  }
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal className="modal fade" show={state.addLeave} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Leave</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'addLeaveClose'});}}></Button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                <label htmlFor="author" className="text-black font-w500">Staff Member<span className="required"> *</span> </label>
                <Select
                    placeholder="Staff"
                    closeMenuOnSelect={true}
                    options={staff}
                    // defaultValue={selectedBarber}
                    onChange={(e) => {setSelectedStaff({value:e.value ,label: e.label})}}
                />
                {errors.staff && <div className="mt-2 text-danger fs-12">{errors.staff}</div>}
              </div>
              <div className="mt-4 col-6">
                <label htmlFor="author" className="text-black font-w500">Start Date<span className="required"> *</span> </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // minutesStep={minStep}
                    reduceAnimations
                    disablePast
                    // defaultValue={startDateHoliday}
                    format="DD/MM/YYYY"
                    ampm={false}
                    skipDisabled
                    onChange={(e) => {setStartDate(e);}}
                  />
                  {errors.startDate && <div className="mt-2 text-danger fs-12">{errors.startDate}</div>}
                </LocalizationProvider>
              </div>
              <div className="mt-4 col-6">
                <label htmlFor="author" className="text-black font-w500">End Date<span className="required"> *</span> </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // minutesStep={minStep}
                    reduceAnimations
                    disablePast
                    // defaultValue={endDate}
                    format="DD/MM/YYYY"
                    ampm={false}
                    skipDisabled
                    onChange={(e) => {setEndDate(e);}}
                  />
                  {errors.endDate && <div className="mt-2 text-danger fs-12">{errors.endDate}</div>}
                </LocalizationProvider>
              </div>
              <div style={{display:'flex', justifyContent:'end'}}>
                <Link to={"#"} className="mt-4 btn-custom btn-primary" onClick={SubmitLeave}>Add Leave</Link>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal className="modal fade" show={state.editLeave} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Leave</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'editLeaveClose'});}}></Button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                <label htmlFor="author" className="text-black font-w500">Staff Member<span className="required"> *</span> </label>
                <Select
                    placeholder="Staff"
                    closeMenuOnSelect={true}
                    options={staff}
                    defaultValue={selectedStaff}
                    onChange={(e) => {setSelectedStaff({value:e.value ,label: e.label})}}
                />
                {errors.staff && <div className="mt-2 text-danger fs-12">{errors.staff}</div>}
              </div>
              <div className="mt-4 col-6">
                <label htmlFor="author" className="text-black font-w500">Start Date<span className="required"> *</span> </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // minutesStep={minStep}
                    reduceAnimations
                    disablePast
                    defaultValue={startDate}
                    format="DD/MM/YYYY"
                    ampm={false}
                    skipDisabled
                    onChange={(e) => {setStartDate(e);}}
                  />
                  {errors.startDate && <div className="mt-2 text-danger fs-12">{errors.startDate}</div>}
                </LocalizationProvider>
              </div>
              <div className="mt-4 col-6">
                <label htmlFor="author" className="text-black font-w500">End Date<span className="required"> *</span> </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // minutesStep={minStep}
                    reduceAnimations
                    disablePast
                    defaultValue={endDate}
                    format="DD/MM/YYYY"
                    ampm={false}
                    skipDisabled
                    onChange={(e) => {setEndDate(e);}}
                  />
                  {errors.endDate && <div className="mt-2 text-danger fs-12">{errors.endDate}</div>}
                </LocalizationProvider>
              </div>
              <div style={{display:'flex', justifyContent:"space-between", marginTop:"2rem"}}>
                <div>
                  <Link style={{backgroundColor:"red"}} to={"#"} onClick={SubmitDeleteLeave} className="mt-4 btn-custom btn-primary">Delete</Link>
                </div>
                <div>
                  <Link to={"#"} className="mt-4 btn-custom btn-primary" onClick={SubmitEditLeave}>Edit Leave</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
    );
  };

  export default Roster;